import _regeneratorRuntime from "@babel/runtime/regenerator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { isCloudflareWorkers } from './env.js';
import crypto, { isCryptoKey } from './webcrypto.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import { encodeBase64 } from './base64url.js';
import formatPEM from '../lib/format_pem.js';
import { JOSENotSupported } from '../util/errors.js';
import { types } from './is_key_like.js';

var genericExport = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(keyType, keyFormat, key) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isCryptoKey(key)) {
              _context.next = 2;
              break;
            }

            throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types))));

          case 2:
            if (key.extractable) {
              _context.next = 4;
              break;
            }

            throw new TypeError('CryptoKey is not extractable');

          case 4:
            if (!(key.type !== keyType)) {
              _context.next = 6;
              break;
            }

            throw new TypeError("key is not a ".concat(keyType, " key"));

          case 6:
            _context.t0 = formatPEM;
            _context.t1 = encodeBase64;
            _context.t2 = Uint8Array;
            _context.next = 11;
            return crypto.subtle.exportKey(keyFormat, key);

          case 11:
            _context.t3 = _context.sent;
            _context.t4 = new _context.t2(_context.t3);
            _context.t5 = (0, _context.t1)(_context.t4);
            _context.t6 = "".concat(keyType.toUpperCase(), " KEY");
            return _context.abrupt("return", (0, _context.t0)(_context.t5, _context.t6));

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function genericExport(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export var toSPKI = function toSPKI(key) {
  return genericExport('public', 'spki', key);
};
export var toPKCS8 = function toPKCS8(key) {
  return genericExport('private', 'pkcs8', key);
};

var findOid = function findOid(keyData, oid) {
  var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (from === 0) {
    oid.unshift(oid.length);
    oid.unshift(0x06);
  }

  var i = keyData.indexOf(oid[0], from);
  if (i === -1) return false;
  var sub = keyData.subarray(i, i + oid.length);
  if (sub.length !== oid.length) return false;
  return sub.every(function (value, index) {
    return value === oid[index];
  }) || findOid(keyData, oid, i + 1);
};

var getNamedCurve = function getNamedCurve(keyData) {
  switch (true) {
    case findOid(keyData, [0x2a, 0x86, 0x48, 0xce, 0x3d, 0x03, 0x01, 0x07]):
      return 'P-256';

    case findOid(keyData, [0x2b, 0x81, 0x04, 0x00, 0x22]):
      return 'P-384';

    case findOid(keyData, [0x2b, 0x81, 0x04, 0x00, 0x23]):
      return 'P-521';

    case findOid(keyData, [0x2b, 0x65, 0x6e]):
      return 'X25519';

    case findOid(keyData, [0x2b, 0x65, 0x6f]):
      return 'X448';

    case findOid(keyData, [0x2b, 0x65, 0x70]):
      return 'Ed25519';

    case findOid(keyData, [0x2b, 0x65, 0x71]):
      return 'Ed448';

    default:
      throw new JOSENotSupported('Invalid or unsupported EC Key Curve or OKP Key Sub Type');
  }
};

var genericImport = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(replace, keyFormat, pem, alg, options) {
    var _a, algorithm, keyUsages, keyData, isPublic, namedCurve, _namedCurve;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            keyData = new Uint8Array(atob(pem.replace(replace, '')).split('').map(function (c) {
              return c.charCodeAt(0);
            }));
            isPublic = keyFormat === 'spki';
            _context2.t0 = alg;
            _context2.next = _context2.t0 === 'PS256' ? 5 : _context2.t0 === 'PS384' ? 5 : _context2.t0 === 'PS512' ? 5 : _context2.t0 === 'RS256' ? 8 : _context2.t0 === 'RS384' ? 8 : _context2.t0 === 'RS512' ? 8 : _context2.t0 === 'RSA-OAEP' ? 11 : _context2.t0 === 'RSA-OAEP-256' ? 11 : _context2.t0 === 'RSA-OAEP-384' ? 11 : _context2.t0 === 'RSA-OAEP-512' ? 11 : _context2.t0 === 'ES256' ? 14 : _context2.t0 === 'ES384' ? 17 : _context2.t0 === 'ES512' ? 20 : _context2.t0 === 'ECDH-ES' ? 23 : _context2.t0 === 'ECDH-ES+A128KW' ? 23 : _context2.t0 === 'ECDH-ES+A192KW' ? 23 : _context2.t0 === 'ECDH-ES+A256KW' ? 23 : _context2.t0 === (isCloudflareWorkers() && 'EdDSA') ? 27 : _context2.t0 === 'EdDSA' ? 31 : 34;
            break;

          case 5:
            algorithm = {
              name: 'RSA-PSS',
              hash: "SHA-".concat(alg.slice(-3))
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 35);

          case 8:
            algorithm = {
              name: 'RSASSA-PKCS1-v1_5',
              hash: "SHA-".concat(alg.slice(-3))
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 35);

          case 11:
            algorithm = {
              name: 'RSA-OAEP',
              hash: "SHA-".concat(parseInt(alg.slice(-3), 10) || 1)
            };
            keyUsages = isPublic ? ['encrypt', 'wrapKey'] : ['decrypt', 'unwrapKey'];
            return _context2.abrupt("break", 35);

          case 14:
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-256'
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 35);

          case 17:
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-384'
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 35);

          case 20:
            algorithm = {
              name: 'ECDSA',
              namedCurve: 'P-521'
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 35);

          case 23:
            namedCurve = getNamedCurve(keyData);
            algorithm = namedCurve.startsWith('P-') ? {
              name: 'ECDH',
              namedCurve: namedCurve
            } : {
              name: namedCurve
            };
            keyUsages = isPublic ? [] : ['deriveBits'];
            return _context2.abrupt("break", 35);

          case 27:
            _namedCurve = getNamedCurve(keyData).toUpperCase();
            algorithm = {
              name: "NODE-".concat(_namedCurve),
              namedCurve: "NODE-".concat(_namedCurve)
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 35);

          case 31:
            algorithm = {
              name: getNamedCurve(keyData)
            };
            keyUsages = isPublic ? ['verify'] : ['sign'];
            return _context2.abrupt("break", 35);

          case 34:
            throw new JOSENotSupported('Invalid or unsupported "alg" (Algorithm) value');

          case 35:
            return _context2.abrupt("return", crypto.subtle.importKey(keyFormat, keyData, algorithm, (_a = options === null || options === void 0 ? void 0 : options.extractable) !== null && _a !== void 0 ? _a : false, keyUsages));

          case 36:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function genericImport(_x4, _x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

export var fromPKCS8 = function fromPKCS8(pem, alg, options) {
  return genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, 'pkcs8', pem, alg, options);
};
export var fromSPKI = function fromSPKI(pem, alg, options) {
  return genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, 'spki', pem, alg, options);
};